import register from '../register';

register( 'neighborhood-list-dropdown', () => {

  const dropdown = document.querySelector('.neighborhood-dropdown');
  const lists = document.querySelectorAll('.neighborhood-list');

  function handleClick( e ) {
    const city = e.target.dataset.option;
    const list = document.querySelector( `[data-city="${ city }"]` );

    if ( city ) {
      lists.forEach( l => l.classList.add('hidden') );
      list.classList.remove('hidden');
    }
  }

  dropdown.addEventListener( 'click', handleClick );

});

export default undefined;
